import { useQuery, UseQueryOptions } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { BrandVisualAnalysis } from 'types'
import { sendToApi } from 'api/client'

export interface Props {
  workspaceId: number
  id: number
}

export type Data = { brand_visual_analysis: BrandVisualAnalysis }

export const useBrandVisualAnalysis = ({ workspaceId, id }: Props, options?: UseQueryOptions<Data>) => {
  return useQuery<Data>(
    ['brandVisualAnalyses', id],
    async () => {
      const res = await sendToApi(`/w/${workspaceId}/brand_visual_analyses/${id}`)

      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
